import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface CheckMappingModalInput {
	noNguid: {
		layers: {
			index: number;
			name: string;
		}[];
		sq: number; // sequence
	};
	unMapped: {
		layers: {
			index: number;
			name: string;
			cols: any[];
		}[];
		sq: number; // sequence
	},
	unMappedFishbone: {
		layers: {
			index: number;
			name: string;
			cols: any[];
		}[];
		sq: number; // sequence
	}
}
@Component({
	selector: 'app-modal-check-mapping',
	templateUrl: './modal-check-mapping.component.html',
	styleUrls: ['./modal-check-mapping.component.css']
})
export class ModalCheckMappingComponent implements OnInit {

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: CheckMappingModalInput,
		public dialogRef: MatDialogRef<ModalCheckMappingComponent>
	) { }

	ngOnInit() {
	}

}
